import _ from "lodash";

export function missingAny(object, paths) {
  return !paths.every((p) => _.has(object, p));
}

export function hasAnyNonNilValue(object) {
  return _.some(object, (val) => !_.isNil(val));
}
